import * as Ladda from 'ladda';

export class ResourceUtils {
	/**
	 * @param {string|null} popupUrl
	 * @param {string} inputFieldLabel
	 *
	 * @return {Promise<{data: string|null, url: string|null, caption: string, author: string|null}>}
	 */
	static selectResourceByUrl(
		popupUrl = null,
		uploadEndpoint = null,
		inputFieldLabel = "Incolla l'URL della risorsa",
		customUploadFunction = null,
		secondaryUrlWithMessage = false,
		hideFields = false,
		showPreview = true,
	) {
		return new Promise(async function (resolve, _reject) {
			const urlSelector = '#resource-url';
			const secondaryUrlSelector = '#resource-secondary-url';
			const applySelector = '#resource-apply-url';
			$.magnificPopup.open({
				items: {
					src: $('#popup'),
				},
				type: 'inline',
				midClick: true,
				closeOnBgClick: false,
				callbacks: {
					open: function () {
						$('#popup-content').empty();

						$('#popup-content').html(
							(popupUrl
								? `<div class="row mt-30">
									<div class="col-md-12 d-flex">
										<div class=" d-flex flex-one">
											<iframe src="${popupUrl}${
												!popupUrl.includes('popup') ? `${popupUrl.includes('?') ? '&' : '?'}popup=true` : ''
											}" width="100%" height="100%" style="min-height:calc(100vh - 200px);" class="border bg-grey-100"></iframe>
										</div>
									</div>
								</div>`
								: '') +
								`<div class="row mt-${!popupUrl ? '30' : '10'}">
									<div class="col-md-12 d-flex">
										<div class="${hideFields ? 'hidden' : 'd-flex flex-column flex-one mr-10'}">
											<h6 class="m-0 font-size-12"><label for="resource-url">${inputFieldLabel}</label></h6>
											<div class="${showPreview ? 'border rounded h-full' : ''}">
												<input id="resource-url" type="url" class="form-control ${showPreview ? 'border-0' : ''}" name="url" value="" style="${
													popupUrl ? 'border: 2px solid var(--primary);' : ''
												}">
											</div>
											${
												secondaryUrlWithMessage
													? `
													<h6 class="font-size-12 mt-1 mb-0"><label for="resource-secondary-url">${secondaryUrlWithMessage}</label></h6>
													<input id="resource-secondary-url" type="url" class="form-control" name="secondary-url" value="">`
													: ''
											}
										</div>

										${
											showPreview
												? `<div class="resource-preview-container mr-10">
											<img class="img-fluid resource-preview-url" src="" alt="" style="object-fit: contain; max-width: 200px; max-height: 100px;">
										</div>`
												: ''
										}

										<div class="${hideFields ? 'w-full' : 'd-flex'}">
											<button type="button" id="resource-apply-url" class="btn btn-primary ladda-button w-full" data-style="zoom-in">
												<i class="fa-solid fa-check mr-1"></i>
												<span class="ladda-label">Conferma</span>
											</button>
										</div>
									</div>
								</div>`,
						);
						setTimeout(function () {
							const $urlField = $(urlSelector);
							const $applyButton = $(applySelector);
							let timeout = null;
							$urlField.on('keyup', function (e) {
								if (e.key === 'Enter' || e.keyCode === 13) {
									$applyButton.trigger('click');
								} else {
									clearTimeout(timeout);
									timeout = setTimeout(function () {
										const $preview = $('.resource-preview-url');
										const newUrl = $urlField.val();
										if ($preview.length && newUrl.length && newUrl.startsWith('http')) {
											$preview.attr('crossOrigin', 'anonymous');
											$preview.attr('src', appconfig.routes.files.stream + '?proxy-url=' + btoa(newUrl));
										} else {
											$preview.attr('src', '');
										}
									}, 300);
								}
							});

							$applyButton.on('click', async function (e) {
								/**
								 * If not valid URL
								 */
								if (!ResourceUtils.validURL($urlField.val())) {
									window.toastr.error('URL inserito non valido');
									$.magnificPopup.close();
									return false;
								}

								if (secondaryUrlWithMessage && $(secondaryUrlSelector).val() !== '' && !ResourceUtils.validURL($(secondaryUrlSelector).val())) {
									window.toastr.error('URL inserito non valido');
									$.magnificPopup.close();
									return false;
								}

								/**
								 * Ladda
								 */
								// Create a new instance of ladda for the specified button
								let aiLaddaBtn = Ladda.create(document.querySelector(applySelector));
								aiLaddaBtn.start();

								if (uploadEndpoint || customUploadFunction) {
									const data = customUploadFunction
										? await customUploadFunction($urlField.val())
										: await ResourceUtils.upload($urlField.val(), uploadEndpoint);
									aiLaddaBtn.stop();
									$.magnificPopup.close();
									resolve(data);
								} else {
									resolve({ url: $urlField.val(), secondaryUrl: $(secondaryUrlSelector).val() });
								}

								setTimeout(function () {
									$.magnificPopup.close();
								}, 300);
							});

							window.addEventListener('message', function (event) {
								if (typeof event.data === 'object') {
									if (event.data.action === 'set-url' && event.data.url) {
										document.getElementById('resource-url').value = event.data.url;
									}
									if (event.data.action === 'set-secondary-url' && event.data.url) {
										document.getElementById('resource-secondary-url').value = event.data.url;
									}
								}
							});
						}, 100);
					},
					close: function () {
						$('#popup-content').empty();
					},
				},
			});
		});
	}

	/**
	 *
	 * @param {Blob} files
	 * @param {string|null} uploadEndpoint
	 * @return {Promise<{data: string|null, url: string|null, caption: string, author: string|null}>}
	 */
	static async uploadNewFileFromReader(files, uploadEndpoint = null, resourceName = 'resource', source = 'locale') {
		try {
			if (!files.length) {
				return Promise.resolve({ data: null, caption: '' });
			}

			function load(file) {
				return new Promise(function (resolve, _reject) {
					const data = { caption: '', author: null, data: null, url: null, source, source_url: null };
					const fileReader = new FileReader();
					fileReader.readAsDataURL(file);
					fileReader.onload = function () {
						data.data = this.result;
						file.src = data.data;
					};

					fileReader.onloadend = function () {
						if (uploadEndpoint) {
							resolve(data);
							return;
						}

						ResourceUtils.extractMetaTags(file)
							.then((tags) => {
								data.author = tags.Copyright || tags.Author || tags.Artist || tags.Creator || tags.creator || tags.AuthorByLine || null;
								const description = tags.Caption || tags.caption || tags.description || tags.ImageDescription || tags.Description || null;
								if (description && description !== '') data.caption += (data.caption.length ? '. ' : '') + description;
							})
							.catch((e) => console.error(e))
							.finally(() => resolve(data));
					};
				});
			}

			const file = files[0];

			// if (!/^image\/\w+$/.test(file.type)) {
			// 	throw new Error('Only images are accepted');
			// }

			if (uploadEndpoint) {
				return Promise.all([ResourceUtils.upload(file, uploadEndpoint, resourceName), load(file)]).then((resp) => ({ ...resp[0], data: resp[1].data }));
			}

			return load(file);
		} catch (e) {
			Promise.reject(e);
		}
	}

	/**
	 * Verify if is valid URL
	 * @param str
	 * @returns {boolean}
	 */
	static validURL(str) {
		try {
			new URL(str);
			return true;
		} catch (e) {
			return false;
		}
		// let pattern = new RegExp(
		// 	'^(https?:\\/\\/)?' + // protocol
		// 		'((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
		// 		'((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
		// 		'(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
		// 		'(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
		// 		'(\\#[-a-z\\d_]*)?$',
		// 	'i',
		// ); // fragment locator
		// return !!pattern.test(str);
	}

	/**
	 *
	 * @param {File|string} file
	 * @param {string} uploadEndopint
	 */
	static async upload(file, uploadEndpoint, resourceName = 'resource') {
		const formData = new FormData();
		formData.append(resourceName, file);

		return new Promise(function (resolve, reject) {
			$.ajax({
				url: uploadEndpoint,
				method: 'POST',
				data: formData,
				processData: false,
				contentType: false,
				success: function (data) {
					resolve({ url: data.file.url, caption: data.file.caption, author: data.file.author });
				},
				error: function (jqXHR, textStatus, errorThrown) {
					reject(textStatus);
				},
			});
		});
	}

	/**
	 *
	 * @param {string|Blob|ArrayBuffer} file
	 * @returns Promise<object>
	 */
	static extractMetaTags(file) {
		return new Promise(function (resolve, reject) {
			EXIF.enableXmp();
			EXIF.getData(file, function () {
				const iptcs = EXIF.getAllTags(this);
				if (this.xmpdata) {
					Object.assign(iptcs, ResourceUtils.#parseXmps(this.xmpdata));
				}
				resolve(iptcs);
			});
		});
	}

	static #parseXmps(tags) {
		const xmps = {};
		if (tags['x:xmpmeta'] && tags['x:xmpmeta']['rdf:RDF'] && tags['x:xmpmeta']['rdf:RDF']['rdf:Description']) {
			const result = tags['x:xmpmeta']['rdf:RDF']['rdf:Description'];
			for (let key in result) {
				if (key === '@attributes') continue;
				ResourceUtils.#cleanXmpStructure(key, result[key], xmps);
			}
		}

		return xmps;
	}

	/**
	 * Attach drag and drop events to an element for handling file/URL drops
	 * @param {HTMLElement} element - The target element for drag events
	 * @param {string} materialType - The type of material (PHOTO, VIDEO, etc.)
	 * @param {Function|null} onDragStart - Callback for drag start (optional)
	 * @param {Function} onDrop - Callback when a file/URL is dropped
	 * @param {Function|null} onDragEnd - Callback for drag end (optional)
	 * @param {number} maxFiles - Maximum number of files to accept (default: 1)
	 */
	static attachDragEvents(element, materialType, onDragStart = null, onDrop, onDragEnd = null, maxFiles = 1) {
		if (!element || !onDrop) return;

		const imageExtensions = ['.jpg', '.jpeg', '.png', '.webp', '.bmp', '.gif'];
		const videoExtensions = ['.mp4', '.webm', '.ogg', '.mov', '.avi'];

		const isValidUrl = (url) => {
			try {
				new URL(url);
				return true;
			} catch {
				return false;
			}
		};

		const isImageUrl = (url) => {
			const lowerUrl = url.toLowerCase();
			return imageExtensions.some((ext) => lowerUrl.includes(ext));
		};

		const isVideoUrl = (url) => {
			const lowerUrl = url.toLowerCase();
			return videoExtensions.some((ext) => lowerUrl.includes(ext));
		};

		const extractUrlFromHtml = (html) => {
			const tempDiv = document.createElement('div');
			tempDiv.innerHTML = html;
			const img = tempDiv.querySelector('img');
			if (img && img.src) return img.src;
			const links = tempDiv.querySelectorAll('a');
			for (const link of links) {
				if (link.href && (isImageUrl(link.href) || isVideoUrl(link.href))) {
					return link.href;
				}
			}
			return null;
		};

		element.addEventListener('dragover', (e) => {
			e.preventDefault();
			e.stopPropagation();
			element.classList.add('drag-over');
		});

		element.addEventListener('dragenter', (e) => {
			e.preventDefault();
			e.stopPropagation();
			element.classList.add('drag-over');
			if (onDragStart) onDragStart(e);
		});

		element.addEventListener('dragleave', (e) => {
			e.preventDefault();
			e.stopPropagation();
			if (!element.contains(e.relatedTarget)) {
				element.classList.remove('drag-over');
				if (onDragEnd) onDragEnd(e);
			}
		});

		element.addEventListener('drop', async (e) => {
			e.preventDefault();
			e.stopPropagation();
			element.classList.remove('drag-over');

			const dataTransfer = e.dataTransfer;
			const files = dataTransfer.files;
			const items = dataTransfer.items;

			// Handle dropped files
			if (files && files.length > 0) {
				const validFiles = Array.from(files).slice(0, maxFiles);
				for (const file of validFiles) {
					if (file.type.startsWith('image/') || file.type.startsWith('video/')) {
						await onDrop(file);
					}
				}
				return;
			}

			// Handle dropped URLs/HTML
			if (items && items.length > 0) {
				let url = null;

				// Try to get URL from different formats
				const htmlData = dataTransfer.getData('text/html');
				const plainData = dataTransfer.getData('text/plain');
				const uriData = dataTransfer.getData('text/uri-list');

				if (uriData && isValidUrl(uriData)) {
					url = uriData;
				} else if (htmlData) {
					url = extractUrlFromHtml(htmlData);
				} else if (plainData && isValidUrl(plainData)) {
					url = plainData;
				}

				if (url) {
					await onDrop(url);
				}
			}

			if (onDragEnd) onDragEnd(e);
		});
	}

	/**
	 * @param {string} key
	 * @param {array|string} tag
	 * @param {object} xmps
	 */
	static #cleanXmpStructure(key, tag, xmps, prevKey = null, depth = 0, visited = new WeakSet()) {
		// Evita troppa ricorsione
		const MAX_DEPTH = 100;
		if (depth > MAX_DEPTH) {
			console.warn('Recursion depth exceeded');
			return;
		}

		// Evita cicli
		if (typeof tag === 'object') {
			if (visited.has(tag)) {
				console.warn('Cycle detected');
				return;
			}
			visited.add(tag);
		}

		if (typeof tag === 'object' && !Array.isArray(tag) && '@attributes' in tag) {
			delete tag['@attributes'];
		}

		const properties = Object.keys(tag);
		if (properties.length === 1 && properties.includes('#text')) {
			let name = key !== 'rdf:li' ? key.slice(key.indexOf(':') + 1) : prevKey.slice(prevKey.indexOf(':') + 1);
			xmps[name] = tag['#text'];
		} else {
			for (let attribute in tag) {
				if (Array.isArray(tag[attribute])) continue;
				ResourceUtils.#cleanXmpStructure(attribute, tag[attribute], xmps, prevKey || (!/\d+/.test(key) ? key : null), depth + 1, visited);
			}
		}
	}
}

export class ImageUtils extends ResourceUtils {
	/**
	 * @param {Function} converter
	 * @param {string|null} popupUrl
	 * @param {string|null} fileUrl
	 * @param {string|null} uploadEndpoint
	 * @param {string} inputFieldLabel
	 * @param {boolean} secondaryUrlWithMessage
	 * @param {boolean} hideFields
	 *
	 * @return {Promise<{data: string|null, url: string|null, caption: string, author: string|null}>}
	 */
	static uploadNewFileFromUrl(
		converter,
		popupUrl = null,
		fileUrl = null,
		uploadEndpoint = null,
		inputFieldLabel = "Incolla l'URL dell'immagine",
		secondaryUrlWithMessage = false,
		hideFields = false,
		showPreview = true,
		source = null,
	) {
		/** @param {string} url */
		async function upload(url) {
			const defaultResponse = {
				url: null,
				data: null,
				caption: '',
				author: null,
				source,
				source_url: null,
			};

			if (uploadEndpoint) {
				const data = await ResourceUtils.upload(url, uploadEndpoint, 'image');
				data.source_url = typeof url === 'string' ? url : null;
				if (!data.url) {
					return defaultResponse;
				}

				const converted = await converter(data.url);
				if (typeof converted !== 'string' && !(converted instanceof Blob)) {
					return defaultResponse;
				}
				data.data = converted;
				return data;
			} else if (fileUrl) {
				const tags = await ResourceUtils.extractMetaTags(fileUrl);
				author = tags.Copyright || tags.Author || tags.Artist || tags.creator || null;
				caption = tags.caption || tags.description || tags.ImageDescription || tags.Description || '';
				const converted = await converter(url);
				if (typeof converted !== 'string') {
					return defaultResponse;
				}
				return {
					url: null,
					data: converted,
					caption,
					author,
					source,
					source_url: fileUrl,
				};
			}

			const converted = await converter(url);
			if (typeof converted !== 'string') {
				return defaultResponse;
			}

			return {
				url: null,
				data: converted,
				caption: '',
				author: null,
				source,
				source_url: url,
			};
		}

		return new Promise(async function (resolve, _reject) {
			if (fileUrl && uploadEndpoint) {
				const data = await upload(fileUrl);
				resolve(data);
			} else {
				resolve(
					await ResourceUtils.selectResourceByUrl(
						popupUrl,
						uploadEndpoint,
						inputFieldLabel,
						upload,
						secondaryUrlWithMessage,
						hideFields,
						showPreview,
					),
				);
			}
		});
	}

	/**
	 *
	 * @param {Blob} files
	 * @param {string|null} uploadEndpoint
	 * @return {Promise<{data: string|null, url: string|null, caption: string, author: string|null}>}
	 */
	static async uploadNewFileFromReader(files, uploadEndpoint = null, source = 'locale') {
		try {
			if (!files.length) {
				return Promise.resolve({ data: null, caption: '' });
			}

			const file = files[0];

			if (!/^image\/\w+$/.test(file.type)) {
				throw new Error('Only images are accepted');
			}

			return ResourceUtils.uploadNewFileFromReader(files, uploadEndpoint, 'image', source);
		} catch (e) {
			Promise.reject(e);
		}
	}

	/**
	 * Transform URL to Base64
	 * @param src
	 * @param callback
	 * @param outputFormat
	 * @return Promise<string>
	 */
	static toDataURL(src, outputFormat) {
		if (!src) return Promise.reject(new Error('URL non valido'));

		return new Promise(function (resolve, reject) {
			const image = new Image();
			image.crossOrigin = 'anonymous';
			image.onload = function (e) {
				const canvas = document.createElement('canvas');
				const ctx = canvas.getContext('2d');
				canvas.height = this.naturalHeight;
				canvas.width = this.naturalWidth;
				ctx.drawImage(this, 0, 0);
				const dataURL = canvas.toDataURL(outputFormat);
				resolve(dataURL);
			};
			image.src = src;
			if (image.complete || image.complete === undefined) {
				image.src = 'data:image/gif;base64, R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';
				image.src = src;
			}
		});
	}

	/**
	 * Transform URL to Image Object
	 * @param {*} src
	 * @param {*} callback
	 * @return Promise<File>
	 */
	static toBlobObject(src) {
		if (!src) return Promise.reject(new Error('URL non valido'));

		return new Promise(function (resolve, reject) {
			fetch(appconfig.routes.files.stream + '?proxy-url=' + btoa(src), {
				method: 'GET',
			})
				.then((res) => res.blob())
				.then((blob) => {
					const filename = src.split('/').pop();
					const file = new File([blob], filename, { type: blob.type });
					resolve(file);
				})
				.catch((error) => reject(error));
		});
	}

	handleDroppedFiles(files, inputElementId, maxFiles = null) {
		const allowedTypes = ['image/jpeg', 'image/png', /*'image/gif',*/ 'image/webp', /*'image/svg+xml',*/ 'image/bmp'];
		let imageFiles = Array.from(files).filter((file) => allowedTypes.includes(file.type));

		if (maxFiles && imageFiles.length > maxFiles) {
			imageFiles = imageFiles.slice(0, maxFiles);
		}

		const fileInput = document.getElementById(inputElementId);
		if (fileInput && imageFiles.length > 0) {
			const dataTransfer = new DataTransfer();
			imageFiles.forEach((file) => dataTransfer.items.add(file));
			fileInput.files = dataTransfer.files;
			fileInput.dispatchEvent(new Event('change'));
		}
	}

	handleDroppedItems(items, dataTransfer, maxFiles = null, uploadCallback = null) {
		const uploadPromises = [];
		for (let i = 0; i < items.length; i++) {
			if (items[i].type.startsWith('image/')) {
				const url = dataTransfer.getData('text/html') || dataTransfer.getData('text/plain');
				if (url) {
					uploadPromises.push(uploadCallback ? uploadCallback(url) : this.uploadFromUrl(null, null, url));
				}
			} else if (items[i].type === 'text/plain') {
				const url = dataTransfer.getData('text/plain');
				if (url && this.isImageUrl(url)) {
					uploadPromises.push(uploadCallback ? uploadCallback(url) : this.uploadFromUrl(null, null, url));
				}
			} else if (items[i].type === 'text/html') {
				const html = dataTransfer.getData('text/html');
				const imageUrl = this.extractImageUrlFromHtml(html);
				if (imageUrl) {
					uploadPromises.push(uploadCallback ? uploadCallback(imageUrl) : this.uploadFromUrl(null, null, imageUrl));
				}
			}
			if (maxFiles && uploadPromises.length >= maxFiles) {
				break;
			}
		}

		return Promise.all(uploadPromises);
	}

	/**
	 * Verifica se un URL punta a un'immagine
	 * @param {string} url - URL da verificare
	 * @returns {boolean}
	 */
	isImageUrl(url) {
		const imageExtensions = ['.jpg', '.jpeg', '.png', /*'.gif',*/ '.webp', /*'.svg',*/ '.bmp'];
		const lowerUrl = url.toLowerCase();

		// Controlla estensioni di file
		if (imageExtensions.some((ext) => lowerUrl.includes(ext))) {
			return true;
		}

		// Controlla se contiene parole chiave comuni per immagini
		// const imageKeywords = ['image', 'img', 'photo', 'picture'];
		// if (imageKeywords.some((keyword) => lowerUrl.includes(keyword))) {
		// 	return true;
		// }

		return false;
	}

	/**
	 * Estrae l'URL di un'immagine da HTML
	 * @param {string} html - HTML da analizzare
	 * @returns {string|null} URL dell'immagine o null
	 */
	extractImageUrlFromHtml(html) {
		// Crea un elemento temporaneo per parsare l'HTML
		const tempDiv = document.createElement('div');
		tempDiv.innerHTML = html;

		// Cerca tag img
		const img = tempDiv.querySelector('img');
		if (img && img.src) {
			return img.src;
		}

		// Cerca link che potrebbero essere immagini
		const links = tempDiv.querySelectorAll('a');
		for (const link of links) {
			if (link.href && this.isImageUrl(link.href)) {
				return link.href;
			}
		}

		return null;
	}
}

export class CropUtils extends ImageUtils {
	#crops = {};
	#container_prefix = null;
	#cropUpdated = false;
	#cropEnabled = false;
	#init = false;
	#enableAutoCrop = false;
	#tracker = {};

	// FIXME: non sto mai attivando l'auto inquadramento delle immagini per motivi di performance e malfunzionamenti
	constructor(cropConfigs, modelCropsData = {}, checkRoute = null, container_prefix = null, enableAutoCrop = false) {
		super();
		this.#container_prefix = container_prefix;
		this.#initCrops(cropConfigs, modelCropsData);
		this.#initEvents();
		this.#enableAutoCrop = enableAutoCrop;

		if (checkRoute) {
			this.#checkCropsExistence(checkRoute);
		}
	}

	get crops() {
		return this.#crops;
	}

	get cropUpdated() {
		return this.#cropUpdated;
	}

	get cropEnabled() {
		return this.#cropEnabled;
	}

	#initCrops(cropConfigs, modelCropsData) {
		for (const key in cropConfigs) {
			this.#crops[key] = {};
			this.#crops[key].cropper = document.querySelector(this.#container_prefix || `#cropper_${key} img`);
			if (this.#crops[key].cropper && !this.#crops[key].cropper.crossOrigin) {
				this.#crops[key].cropper.crossOrigin = 'anonymous';
			}
			this.#crops[key].ratio = cropConfigs[key].ratio;
			this.#crops[key].width = cropConfigs[key].width;
			this.#crops[key].height = cropConfigs[key].height;
			this.#crops[key].data = typeof modelCropsData !== 'undefined' && modelCropsData[key] !== undefined ? modelCropsData[key] : null;
			this.#crops[key].cropper.addEventListener('cropend', () => {
				this.#cropUpdated = true;
				this.confirmCrop();
				this.#hideBroken(key);
			});
			this.#crops[key].cropper.addEventListener('zoom', () => {
				this.#cropUpdated = true;
				this.confirmCrop();
			});
			// let loaderTimeout = setTimeout(() => {
			$(`.crop-loader-${key}`).show();
			// }, 200);
			this.#crops[key].crop = new Cropper(this.#crops[key].cropper, {
				responsive: true,
				viewMode: 0,
				aspectRatio: this.#crops[key].ratio,
				zoomOnWheel: false,
				zoomOnTouch: false,
				autoCropArea: 1,
				checkCrossOrigin: true,
				data: this.#crops[key].data,
				ready: () => {
					// clearTimeout(loaderTimeout);
					$(`.crop-loader-${key}`).hide();
					if (this.#init) {
						this.#cropEnabled = true;
						this.#cropUpdated = true;
						this.confirmCrop();
					}
				},
				cropstart: () => {
					if (this.#enableAutoCrop) this.stopTracking(key);
				},
			});
		}
		this.#init = true;
	}

	#initEvents() {
		this.#cropEnabled = true;
		const crops = this.#crops;
		$('.crop-action').on('click', (e) => {
			const target = e.currentTarget;
			let input = null;
			const data = {
				method: target.getAttribute('data-method'),
				target: target.getAttribute('data-target'),
				option: target.getAttribute('data-option') || undefined,
				option2: target.getAttribute('data-second-option') || undefined,
			};

			const cropper = crops[data.target]?.crop;

			if (!data.method || !cropper || !cropper[data.method]) return;

			const result = data.option2 ? cropper[data.method](data.option, data.option2) : cropper[data.method](data.option);

			switch (data.method) {
				case 'scaleX':
				case 'scaleY':
					target.setAttribute('data-option', -data.option);
					break;
			}

			if (typeof result === 'object' && result !== cropper && input) {
				try {
					input.value = JSON.stringify(result);
				} catch (e) {
					console.log(e.message);
				}
			}

			this.#cropUpdated = true;
			this.confirmCrop();
		});

		$('[data-reset]').on('click', () => this.resetCrops());
		$('[data-delete]').on('click', () => this.deleteCrops());

		let isChangingEnabledCrops = false;
		let reEnableTimeout = null;
		const updateLock = () => {
			if (reEnableTimeout) {
				clearTimeout(reEnableTimeout);
				reEnableTimeout = null;
			}

			reEnableTimeout = setTimeout(() => {
				this.#toggleCropsLock(true);
				reEnableTimeout = null;
			}, 300);
		};

		window.addEventListener(
			'resize',
			() => {
				if (this.#cropEnabled && !isChangingEnabledCrops) {
					isChangingEnabledCrops = true;
					this.#toggleCropsLock(false);
					isChangingEnabledCrops = false;
				}

				updateLock();
			},
			true,
		);

		const $dropZone = $('.crop-editor .drop-zone');

		// Previeni il comportamento di default del browser
		$(document).on('dragover drop', function (e) {
			e.preventDefault();
		});

		$dropZone.on('dragover', function (e) {
			e.preventDefault();
			e.stopPropagation();
			$(this).addClass('drag-over');
		});

		$dropZone.on('dragenter', function (e) {
			e.preventDefault();
			e.stopPropagation();
			$(this).addClass('drag-over');
		});

		$dropZone.on('dragleave', function (e) {
			e.preventDefault();
			e.stopPropagation();

			// Controlla se il mouse è ancora nell'area
			if (!$(this).has(e.relatedTarget).length) {
				$(this).removeClass('drag-over');
			}
		});

		$dropZone.on('drop', async (e) => {
			e.preventDefault();
			e.stopPropagation();

			$(e.currentTarget).removeClass('drag-over');

			const files = e.originalEvent.dataTransfer.files;
			const items = e.originalEvent.dataTransfer.items;

			if (files.length > 0) {
				this.handleDroppedFiles(files, 'inputImage', 1);
			} else if (items.length > 0) {
				//TODO: a questo punto non so che converter usare e che uploadurl usare
				const uploadedFiles = await this.handleDroppedItems(items, e.originalEvent.dataTransfer, 1, (url) => this.uploadFromUrl(null, null, url));
				console.log(uploadedFiles.shift());
			}
		});
	}

	#signCropAsBroken(el) {
		const $parent = $(el).parent();
		const $next = $parent.next();
		$next.find('.fa-triangle-exclamation').show();
		$next.find('.fa-spinner').hide();

		console.warn('Crop', $parent.parent().attr('data-crop'), 'mancante');
	}

	#signCropAsValid(el) {
		$(el).parent().next().find('.fa-triangle-exclamation').hide();
	}

	/**
	 *
	 * @param {string} checkRoute
	 */
	#checkCropsExistence(checkRoute) {
		if ($('#crop_original').val() && checkRoute) {
			$('.cropper img[data-crop]').each((_idx, el) => {
				const url = $(el).attr('data-crop');
				if (url) {
					$.ajax({
						url: checkRoute + '?url=' + url,
						type: 'GET',
						success: (data) => {
							if (!data.exists) {
								this.#signCropAsBroken(el);
							} else {
								this.#signCropAsValid(el);
							}
						},
						error: (_data) => this.#signCropAsBroken(el),
					});
				}
			});
		}
	}

	#isTrackingAvailable() {
		return typeof window.tracking !== 'undefined' && typeof window.tracking.ObjectTracker === 'function';
	}

	setupAutoCrop(key) {
		if (typeof window.tracking === 'undefined') {
			this.#enableAutoCrop = false;
			console.warn('Tracking.js non disponibile, auto-crop disabilitato');
			return;
		}

		try {
			const cropper = this.#crops[key].crop;

			if (this.#tracker[key]) {
				this.#tracker[key].removeAllListeners();
			}

			this.#tracker[key] = new window.tracking.ObjectTracker('face');
			this.#tracker[key].setEdgesDensity(0.1);
			this.#tracker[key].setInitialScale(4);
			this.#tracker[key].setStepSize(2);

			this.#tracker[key].on('track', (event) => {
				console.log('Track event:', event); // Debug
				if (event.data.length > 0) {
					// console.log('Volti rilevati:', event.data.length); // Debug

					const face = event.data.reduce((prev, current) => (prev.width * prev.height > current.width * current.height ? prev : current));

					// console.log('Volto selezionato:', face); // Debug

					const currentCropBox = cropper.getCropBoxData();
					const faceCenter = {
						x: face.x + face.width / 2,
						y: face.y + face.height / 2,
					};

					// console.log('Centro del volto:', faceCenter); // Debug

					const newPosition = {
						left: Math.max(0, faceCenter.x - currentCropBox.width / 2),
						top: Math.max(0, faceCenter.y - currentCropBox.height / 2),
					};

					const imageData = cropper.getImageData();
					newPosition.left = Math.min(newPosition.left, imageData.width - currentCropBox.width);
					newPosition.top = Math.min(newPosition.top, imageData.height - currentCropBox.height);

					// console.log('Nuova posizione:', newPosition); // Debug

					cropper.setCropBoxData({
						...currentCropBox,
						left: newPosition.left,
						top: newPosition.top,
					});
				} else {
					console.log('Nessun volto rilevato'); // Debug
				}
			});

			this.#tracker[key].on('error', (error) => {
				console.error('Tracking error:', error);
			});

			const imageElement = cropper.element;
			console.log('Avvio tracking su elemento:', imageElement); // Debug

			// Assicuriamoci che l'immagine sia completamente caricata
			if (imageElement.complete) {
				window.tracking.track(imageElement, this.#tracker[key]);
			} else {
				imageElement.onload = () => {
					window.tracking.track(imageElement, this.#tracker[key]);
				};
			}

			console.debug('Face tracking inizializzato');
		} catch (error) {
			console.error("Errore durante l'inizializzazione del face tracking:", error);
			console.error('Stack:', error.stack); // Debug completo dell'errore
		}
	}

	stopTracking(key) {
		if (this.#tracker[key]) {
			this.#tracker[key].removeAllListeners();
			this.#tracker[key] = null;
		}
	}

	#showLoaders() {
		for (const key in this.#crops) {
			this.#showLoader(key);
		}
	}

	#showLoader(loader) {
		console.log('showLoader', loader);
		$(`.crop-uploader-${loader}`).show();
		$(`.crop-loader-${loader}`).hide();
	}

	#hideLoaders() {
		for (const key in this.#crops) {
			this.#hideLoader(key);
		}
	}

	#hideLoader(loader) {
		console.log('hideLoader', loader);
		$(`.crop-uploader-${loader}`).hide();
		$(`.crop-loader-${loader}`).hide();
	}

	#hideBrokens() {
		for (const key in this.#crops) {
			this.#hideBroken(key);
		}
	}

	#hideBroken(loader) {
		$(`.crop-broken-${loader}`).hide();
	}

	confirmCrop() {
		if (!this.cropUpdated) return;

		$('#crop-editor-placeholders-container').hide();
		$('#crop-editor-placeholders-label').hide();
		$('#crop-editor-crops-container').show();
		$('.only-if-original').show();

		const croppedCanvas = this.getCroppedCanvas();
		let isChanged = false;
		for (const key in croppedCanvas) {
			const oldValue = $('#crop_' + key).val();
			const newValue = JSON.stringify(croppedCanvas[key]);
			$('#crop_' + key).val(newValue);
			if (oldValue !== newValue && !isChanged) isChanged = true;
			this.#hideLoader(key);
		}

		if (isChanged) {
			$('#crop_updated').val('true');
			$('#pageForm').trigger('change');
		}
	}

	/**
	 *
	 * @param {boolean} enable
	 */
	#toggleCropsLock(enable) {
		for (const key in this.#crops) {
			this.#crops[key].crop[enable ? 'enable' : 'disable']();
		}
		this.#cropEnabled = enable;
	}

	#setUploaded(data) {
		if (data?.data) {
			this.#cropUpdated = true;
			this.#hideBrokens();
		}
		if (data?.url) {
			$('#crop_original').val(data.url);
			$('.crop-editor .popup-preview-image').attr('crossOrigin', 'anonymous').attr('src', data.url);
			$('.crop-editor [data-copy]').attr('data-copy', data.url);
			$('.crop-editor [data-download]').attr('data-download', data.url);
		}
		const source = data.source?.replace(/http(?:s)?:\/\//, '').replace(/\/(?:.*)/, '') ?? '';
		const source_url = data.source_url ?? '';
		$('#crop_source').val(source);
		$('#crop_source_url').val(source_url);
		$('#source-display').html(`<i class="fa-solid fa-link mr-1 fa-fw"></i> ${source}`);
	}

	async uploadFromUrl(converter, popupUrl = null, fileUrl = null, uploadEndpoint = null, secondaryUrlWithMessage = false, hideFields = false, source = null) {
		try {
			this.#showLoaders();
			const data = await ImageUtils.uploadNewFileFromUrl(
				converter,
				popupUrl,
				fileUrl,
				uploadEndpoint,
				undefined,
				secondaryUrlWithMessage,
				hideFields,
				source,
			);
			this.#setUploaded(data);
			return data;
		} catch (e) {
			console.error(e.message);
			this.#hideLoaders();
		}
	}
	async uploadFromReader(files, uploadEndpoint = null, source = 'locale') {
		try {
			this.#showLoaders();
			const data = await ImageUtils.uploadNewFileFromReader(files, uploadEndpoint, source);
			this.#setUploaded(data);
			return data;
		} catch (e) {
			console.error(e.message);
			this.#hideLoaders();
		}
	}

	replaceCrop(key, dataUrl) {
		if (this.#enableAutoCrop) this.stopTracking(key);
		this.#crops[key].crop.reset().replace(dataUrl);
		if (this.#enableAutoCrop && this.#isTrackingAvailable()) {
			this.setupAutoCrop(key);
		}
	}

	replaceCrops(dataUrl) {
		for (const key in this.#crops) {
			this.replaceCrop(key, dataUrl);
		}
		this.#cropUpdated = true;
		this.confirmCrop();
	}

	resetCrops() {
		for (const key in this.#crops) {
			this.#crops[key].crop.reset();
		}
		this.#cropUpdated = true;
		this.confirmCrop();
	}

	deleteCrops() {
		for (const key in this.#crops) {
			this.#crops[key].crop.destroy();
		}
		$('#crop_original').val(null);
		$('#crop_config').val('{}');
		$('#crop-editor-placeholders-container').show();
		$('#crop-editor-placeholders-label').hide();
		$('#crop-editor-crops-container').hide();
		this.#cropUpdated = true;
		// this.confirmCrop();
		$('#crop_updated').val('true');
		$('#pageForm').trigger('change');
		$('.only-if-original').hide();
	}

	getCroppedCanvas() {
		const croppedCanvas = {};

		for (const key in this.#crops) {
			const canvas = this.#crops[key].crop.getCroppedCanvas({
				fillColor: '#fff',
				width: this.#crops[key].width,
				height: this.#crops[key].height,
			});
			if (canvas) {
				croppedCanvas[key] = {
					dataURL: canvas.toDataURL('image/jpeg', 1),
					cropper: this.#crops[key].crop.getData(),
				};
			}
		}

		return croppedCanvas;
	}
}

// Export di default per compatibilità con i plugin che usano import default
export default ResourceUtils;
